import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../crystal-elements/cc-base.component';
import {OrdersTradesFilter} from '../../model/clearing/orders-trades-filter';
import {TradeTableComponent} from "./table/trade/trade-table.component";
import {OrderTableComponent} from "./table/order/order-table.component";
import {ClearingAllocationService} from "../../services/clearing/clearing-allocation.service";
import {WebTradeOrderView} from "../../model/internal/web-trade-order-view";
import {TradeAggregateTableComponent} from "./table/trade-aggregate/trade-aggregate-table.component";
import {CookieNames} from "../../shared/cookie/cookie-names";
import {OrderClearingTableComponent} from "./table/order-clearing/order-clearing-table.component";
import {CcStorageService} from "../../services/common/cc-storage.service";

@Component({
  selector: 'app-tradesorders[userView]',
  templateUrl: './clearing.component.html',
  styleUrls: ['./clearing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClearingComponent extends CcBaseComponent {
  SHOW_OPTION = WebTradeOrderView.SHOW_OPTION

  @Input()
  userView: WebTradeOrderView;

  @ViewChild('tradeTableEl')
  tradeTableEl: TradeTableComponent;

  @ViewChild('tradeAggregateTableEl')
  tradeAggregateTableEl: TradeAggregateTableComponent;

  @ViewChild('orderTableEl')
  orderTableEl: OrderTableComponent;

  @ViewChild('orderClearingTableEl')
  orderClearingTableEl: OrderClearingTableComponent;

  ordersActive: boolean = true;

  @Input()
  orderClearingsActive: boolean = false;
  @Output()
  orderClearingsActiveChange = new EventEmitter<boolean>();

  tradesActive: boolean = true;
  tradeAggregatesActive: boolean = false;

  items: MenuItem[] = [];

  splitterClass: string = 'max-size-0';

  public innerHeight: number = 1000;
  public splitOrdersPercent: number = 50;
  public splitTradesPercent: number = 50;

  @Input()
  ordersTradesFilter: OrdersTradesFilter = new OrdersTradesFilter();
  @Input()
  selectedOrderIds: string[];
  @Output()
  selectedOrderIdsChange = new EventEmitter<string[]>();

  @Input()
  selectedTradeIds: string[];
  @Output()
  selectedTradeIdsChange = new EventEmitter<string[]>();

  maximizedOrderTable: boolean = false;
  maximizedTradeTable: boolean = false;

  constructor(cdref: ChangeDetectorRef,
              private storageService: CcStorageService,
              private allocationService: ClearingAllocationService,
              protected componentFactoryResolver: ComponentFactoryResolver,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              protected translateService: TranslateService) {
    super(cdref, messageService, translateService);

    if (this.storageService.check(CookieNames.CLEARING_TRADE_AGGREGATES)) {
      if (this.storageService.get(CookieNames.CLEARING_TRADE_AGGREGATES) === 'true') {
        this.tradesActive = false;
        this.tradeAggregatesActive = true;
      }
    }

    if (this.storageService.check(CookieNames.CLEARING_ORDER_TRADEMODE)) {
      if (this.storageService.get(CookieNames.CLEARING_ORDER_TRADEMODE) === 'true') {
        this.ordersActive = false;
        this.orderClearingsActive = true;
      }
    }
  }

  // ngOnInit() {
  // }

  // tslint:disable-next-line:use-life-cycle-interface
  // ngOnDestroy(): void {
  // }

  headerFooterMargin: number = 57;

  onSplitterResize(leftSize: number, rightSize: number) {
    let orderTableEl = this.ordersActive ? this.orderTableEl : this.orderClearingTableEl;
    let tradeTableEl = this.tradesActive ? this.tradeTableEl : this.tradeAggregateTableEl;
    if (tradeTableEl && orderTableEl) {
      this.splitOrdersPercent = leftSize; // leftSize > 0 ? (leftSize < 85 ? leftSize : 85) : 0;
      this.splitTradesPercent = rightSize; // rightSize > 0 ? (rightSize < 85 ? rightSize : 85) : 0;
      orderTableEl.scrollHeight = Math.max(Math.round(this.innerHeight * this.splitOrdersPercent / 100
        - this.headerFooterMargin), 0); // -30 -32
      tradeTableEl.scrollHeight = Math.max(Math.round(this.innerHeight * this.splitTradesPercent / 100
        - this.headerFooterMargin), 0); // -30 -32
      if (orderTableEl.scrollHeight == 0) {
        tradeTableEl.scrollHeight = this.innerHeight - (this.headerFooterMargin * 2);
      } else if (leftSize > 50 && leftSize < 100) {
        orderTableEl.scrollHeight += Math.round((100 - leftSize) / 100 * 10);
      }
      if (tradeTableEl.scrollHeight == 0) {
        orderTableEl.scrollHeight = this.innerHeight - (this.headerFooterMargin * 2);
      } else if (rightSize > 50 && rightSize < 100) {
        tradeTableEl.scrollHeight += Math.round((100 - rightSize) / 100 * 10);
      }
      // orderTableEl.scrollHeight = this.innerHeight * this.splitOrdersPercent / 100 - 60 - 45 + 'px';
      // tradeTableEl.scrollHeight = this.innerHeight * this.splitTradesPercent / 100 - 60 - 45 + 'px';
      // console.log('----> this.innerHeight ' + this.innerHeight);
      // console.log('----> leftSize ' + this.splitOrdersPercent);
      // console.log('----> rightSize ' + this.splitTradesPercent);
      // console.log('----> tradeTableEl.scrollHeight ' + tradeTableEl.scrollHeight)
      // console.log('----> orderTableEl.scrollHeight ' + orderTableEl.scrollHeight)
      orderTableEl.markForCheck();
      tradeTableEl.markForCheck();
    } else if (orderTableEl) {
      orderTableEl.scrollHeight = this.innerHeight - this.headerFooterMargin - 10;
      orderTableEl.markForCheck();
    } else if (tradeTableEl) {
      tradeTableEl.scrollHeight = this.innerHeight - this.headerFooterMargin - 10;
      tradeTableEl.markForCheck();
    }
    if (leftSize > 50) {
      this.maximizedOrderTable = true;
      this.maximizedTradeTable = false;
    } else if (rightSize > 50) {
      this.maximizedOrderTable = false;
      this.maximizedTradeTable = true;
    }
    this.markForCheck();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    setTimeout(() => {
      this.innerHeight = window.innerHeight - this.headerFooterMargin / 2;
      this.onSplitterResize(this.splitOrdersPercent, this.splitTradesPercent);
    });
  }

  ngAfterViewInit(): void {
    this.onResize(null);
    this.refreshTables();
    // setTimeout(() => {
    //   this.onResize(null);
    //   window.dispatchEvent(new Event('resize'));
    // });
  }

  // refreshRecords(): void {
  //   setTimeout(() => {
  //    const request: OrdersTradesTableRequest = new OrdersTradesTableRequest();
  //     request.filters.push(...UserView.toFilters(this.userView));
  //   });
  // }

  splitterDblCick($event: MouseEvent) {
    // console.log("------> " + JSON.stringify($event));
  }

  maximizeOrder(maximized: boolean) {
    let orderTableEl = this.ordersActive ? this.orderTableEl : this.orderClearingTableEl;
    let tradeTableEl = this.tradesActive ? this.tradeTableEl : this.tradeAggregateTableEl;
    if (maximized) {
      this.onSplitterResize(100, 0);
      orderTableEl.reload();
    } else {
      this.onSplitterResize(50, 50);
      orderTableEl.reload();
      tradeTableEl.reload();
    }
    this.maximizedTradeTable = false;
    // if (orderTableEl && tradeTableEl) {
    //   orderTableEl.detectChanges();
    //   tradeTableEl.detectChanges();
    // } else if (orderTableEl) {
    //   orderTableEl.detectChanges();
    // } else if (tradeTableEl) {
    //   tradeTableEl.detectChanges();
    // }
  }

  maximizeTrade(maximized: boolean) {
    let orderTableEl = this.ordersActive ? this.orderTableEl : this.orderClearingTableEl;
    let tradeTableEl = this.tradesActive ? this.tradeTableEl : this.tradeAggregateTableEl;
    if (maximized) {
      this.onSplitterResize(0, 100);
      tradeTableEl.reload();
    } else {
      this.onSplitterResize(50, 50);
      orderTableEl.reload();
      tradeTableEl.reload();
    }
    this.maximizedOrderTable = false;
    // if (orderTableEl && tradeTableEl) {
    //   orderTableEl.detectChanges();
    //   tradeTableEl.detectChanges();
    // } else if (orderTableEl) {
    //   orderTableEl.detectChanges();
    // } else if (tradeTableEl) {
    //   tradeTableEl.detectChanges();
    // }
  }

  orderSelectionChanged($event) {
    this.selectedOrderIdsChange.emit($event);
    this.closeTradeSelectionInfo();
  }

  closeTradeSelectionInfo() {
    if (this.tradeTableEl)
      this.tradeTableEl.closeTradeSelectionInfo();
  }

  public refreshTables() {
    let orderTableEl = this.ordersActive ? this.orderTableEl : this.orderClearingTableEl;
    let tradeTableEl = this.tradesActive ? this.tradeTableEl : this.tradeAggregateTableEl;
    if (orderTableEl)
      orderTableEl.reload();
    if (tradeTableEl)
      tradeTableEl.reload();
  }

  tradeAggregatesActiveChanged(active: boolean) {
    this.storageService.set(CookieNames.CLEARING_TRADE_AGGREGATES, JSON.stringify(active));
    this.tradeAggregatesActive = active;
    this.tradesActive = !active;
    this.onResize();
  }

  orderClearingsActiveChanged(active: boolean) {
    this.storageService.set(CookieNames.CLEARING_ORDER_TRADEMODE, JSON.stringify(active));
    this.orderClearingsActive = active;
    this.ordersActive = !active;
    this.onResize();
    this.orderClearingsActiveChange.emit(active);
  }
}

